        <app-app-headers [headerProps]="buttonHeaderProps"></app-app-headers>
       <app-table-component (onPagination)="onPagination($event)"
                         (selectedItem)="actionButtonOutput($event)"
                         [props]="tableConfigAndProps"></app-table-component>
